import React from 'react';
import { Checkbox,Button  } from 'antd';

import Badge from '../bages';

import Arrow from '../../../assets/icons/circle-right-arrow.svg';

import { capitalize } from 'lodash';

import { PoCardItemWrapper } from './style';

const PoCardItem = ({
  key,
  userName,
  onClick,
  userEmail,
  poName,
  vendor,
  status,
  totalInvoiceQty,
  receivedQty,
  setIsModalOpen,
  setId,
  cardClick
}) => {
  return (
    <PoCardItemWrapper>
      <div  onClick={cardClick}>
      <div className='cards-title'>
        <div className='cards-item'>
          <p>{userName}</p>
          <p>{userEmail}</p>
        </div>
        <div className='cards-item'>
          <p>PO Name</p>
          <p>{poName}</p>
        </div> 
        <div onClick={onClick} className='cards-item'>
          <img src={Arrow} alt='Arrow Icon' title='Arrow Icon' />
        </div>
      </div>
      <div className='cards-content-wrapper'>
        <div className='cards-content'>
          <p>Vendor:</p>
          <p>{vendor || 'N/A'}</p>
        </div>
        <div className='cards-content'>
          <p>Status:</p>
          <Badge simpleText status={capitalize(status) || 'N/A'} />
        </div>
        <div className='cards-content'>
          <p>Total Invoice Qty:</p>
          <p>{totalInvoiceQty || 0}</p>
        </div>
        <div className='cards-content'>
          <p>Received Qty:</p>
          <p>{receivedQty || 0}</p>
        </div>
      </div>
      </div>
       <Button className={ status?.toLowerCase() === 'confirmed' ? "map-btn-wrapper" : 'disabled-save-button'} onClick={()=>{
              setId()
              setIsModalOpen(true)
              }}>Mark As Arrived</Button>
    </PoCardItemWrapper>
  );
};

export default PoCardItem;
